<template>
  <div v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
    <el-card class="searchItemFlex">
      <el-form ref="QueryForm" inline :model="query">
        <el-form-item prop="dividedDate">
          <el-date-picker v-model="query.dividedDate" type="date" placeholder="请选择派发日期" value-format="yyyy-MM-dd" @change="changeDividedDate"></el-date-picker>
        </el-form-item>
        <el-form-item prop="userName">
          <el-input v-model="query.userName" placeholder="派发用户" clearable></el-input>
        </el-form-item>
        <el-form-item prop="projectName">
          <el-input v-model="query.projectName" placeholder="派发项目名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" icon="el-icon-download" class="right" @click="exportList">导出列表</el-button>
    </el-card>
    <el-card>
      <el-table :data="dividedList" id="PhotoProTable" ref="PhotoProTable" height="610" border>
        <el-empty description="暂无数据" slot="empty"></el-empty>
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column label="拍摄人" prop="dividedUserName" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="拍摄项目" prop="projectName" width="240" show-overflow-tooltip sortable>
          <template v-slot="{ row }">
            <span>{{ `${row.projectNum}(${row.projectName})` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拟拍节点" prop="contentName" width="140" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ `${row.contentNumber} ${row.contentName}` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拍摄类型" prop="photoType" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="对方联系方式" width="160" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ `(${row.contactMan})[${row.contactTel}]` }}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目地点" prop="location" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="派发时间" prop="responseTime" width="140" show-overflow-tooltip>
          <template v-slot="{ row }">
            <span>{{ row.responseTime | dateformatAll('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拍摄人签字" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="审核人签字" width="90" show-overflow-tooltip></el-table-column>
        <el-table-column label="备注" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作">
          <template v-slot="{ row }">
            <el-button v-permission="['phototask_temp_assign']" type="text" @click="deleteHistory(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import dayjs from "dayjs"
import FileSaver from "file-saver"
import XLSX from "xlsx"
import { dividedList, deleteDivideHistory } from '@/api/projectResponse'
export default {
  name: 'DividedTask',
  data() {
    return {
      loading: false,
      query: {
        dividedDate: null,
        userName: '',
        projectName: '',
      },
      dividedList: [],
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    async getList() {
      this.loading = true
      if (!this.query.dividedDate) {
        this.query.dividedDate = dayjs(new Date()).format('YYYY-MM-DD')
      }
      const { data: res } = await dividedList(this.query).catch(err => err)
      if (res) {
        this.dividedList = res
      }
      this.loading = false
    },
    reset() {
      this.$refs.QueryForm.resetFields()
      this.getList()
    },
    exportList() {
      if (this.dividedList.length <= 0) {
        return this.$message.warning('暂无数据，请尝试查询后再试。')
      }
      this.loading = true
      this.$message.warning("正在导出开票列表数据...")
      var xlsxParam = { raw: true } //转换成excel时，使用原始的格式
      var wb = XLSX.utils.table_to_book(
        document.querySelector("#PhotoProTable"),
        xlsxParam
      ) //outTable为列表id
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream;charset=utf-8",
          }),
          "声像拍摄任务派发单导出_" +
            this.query.dividedDate +
            ".xlsx"
        )
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout)
      }
      this.loading = false
      //导出完成
      this.$message.success("导出成功！")
      return wbout
    },
    changeDividedDate(val) {
      if (!val) {
        this.query.dividedDate = val
        this.$nextTick(() => {
          this.query.dividedDate = dayjs(new Date()).format('YYYY-MM-DD')
        })
      } else {
        this.query.dividedDate = val
      }
    },
    async deleteHistory(row) {
      const conf = await this.$confirm('将要删除该条派发记录，删除后不可回溯！请确定是否继续？', '提示', { type: 'warning' }).catch(err => err)
      if (conf !== 'confirm') {
        return this.$message.info('已取消操作。')
      }
      const responseTime = dayjs(row.responseTime).format('YYYY-MM-DD HH:mm:ss.SSS')
      const { data: res } = await deleteDivideHistory(row.panum, row.templateContentId, row.responsible, responseTime).catch(err => err)
      if (res) {
        this.$message.success('操作成功！')
        this.getList()
      }
    },
  },
}
</script>
<style scoped lang="less">
/deep/ .el-form-item{
  margin-bottom: 0px !important;
}
</style>
